import {CardEnum} from '@colonist/game-states'
import {UIGamePopupCardConfirmation} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupCardConfirmation'
import {UIGamePopupConfirmationButtons} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupConfirmationButtons'
import {UIGamePopupInformationView} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupInformationView'

export class UIWGamePopupCardConfirmation extends UIGamePopupCardConfirmation {
    setCancelAction(action: () => void) {
        this.onCancelButton = action
        this.confirmationButtons.cancelButton.updateAction(action)
    }

    protected createPopupView() {
        const cardsWithoutCancelButton = [CardEnum.VictoryPoint, CardEnum.ProgressCardPoliticsConstitution, CardEnum.ProgressCardSciencePrinter]
        const showCancelButton = cardsWithoutCancelButton.includes(this.cardEnum) == false

        const w = this.canvas.popupWidth
        const bottomButtonH = this.canvas.itemSize * 0.55

        const cardInformationW = w - bottomButtonH * 2
        this.cardPopupInformation = new UIGamePopupInformationView(this.uiGameManager, 0, 0, cardInformationW, this.popupInformation, this)

        const padding = this.cardPopupInformation.doesTextExtendBelowImage() ? bottomButtonH / 2 : bottomButtonH
        const bottomButtonY = this.absoluteHeight - padding
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, bottomButtonY, w, bottomButtonH, this.onCheckButton, this.onCancelButton, this, showCancelButton)
        this.confirmationButtons.checkButton.activateOpacity()
    }
}
